import { Platform } from "react-native"

import * as Device from "expo-device"

export const isIos = Platform.OS === "ios"
export const isAndroid = Platform.OS === "android"
export const isDevice = Device.isDevice
export const isSimulator = !isDevice && isIos
